<template>
  <div ref="plotTreeScript">
    <MapModal
      :modalNode="modalNode"
      :title="plotItem.title"
      :id="plotItem.id"
      :close="plotItem_click"
      ref="plotTree"
      class="newModelPosition hierarchy1"
    >
      <template slot="head" v-if="posCode != 'guest'">
        <div class="head-operate">
          <el-button type="primary" size="mini" @click="addPlot">
            <i class="el-icon-zengjia"></i> 新建标绘
          </el-button>
          <el-button type="primary" size="mini" @click="addGrouping">
            <i class="el-icon-zengjia"></i> 新建分组
          </el-button>
          <el-button type="primary" size="mini" @click="addImgResouces">
            <i class="el-icon-zengjia"></i> 文件资源
          </el-button>
        </div>
      </template>
      <template slot="foot">
        <div
          class="foot-operate"
          v-if="!$store.state.isPresentationMode && selectedScene"
        >
          <el-button type="primary" @click="joinScene"> 加入场景 </el-button>
        </div>
      </template>
    </MapModal>

    <!-- 新建分组 -->
    <newGroupingPage
      ref="newGroupingPage"
      v-if="newPageShow"
      :groupProps="groupProps"
      @onSubmitGroupName="onSubmitGroupName"
      @closeNewGrouping="closeNewGrouping"
    >
    </newGroupingPage>

    <scenePlottingClon
      ref="scenePlottingClon"
      v-if="newScenePlotting"
      :oldScenes="selectedScene"
      :grouping="grouping"
      @closeScenePlotting="closeScenePlotting"
    >
    </scenePlottingClon>
    <!-- 标绘组件 -->
    <PlotItemPage
      ref="PlotItemPage"
      v-show="plotItemShow"
      :selectedScene="selectedScene"
      @plotItemClose="plotItemClose"
      @plotSaveSuccessfulTree="getData2"
      @editPlotEmit="editPlotData($event)"
      :currentNode="currentNode"
    ></PlotItemPage>

    <!-- 图片上传 -->
    <ImageResources
      v-if="imageResourcesShow"
      :close="imageResourcesClose"
      :sceneId="currentNode"
      :selectedScene="selectedScene"
      :getSchemeTree="getSchemeTree"
    >
    </ImageResources>
  </div>
</template>

<script>
// 同步
import PlotItemPage from "@/components/tables/plotItem/PlotItem.vue";
const MapModal = () => import("@/components/common/mapModal/Index");
const newGroupingPage = () => import("./newGroupingPage");
const scenePlottingClon = () => import("./scenePlottingClon");
const ImageResources = () => import("@/components/tables/resources/Index.vue");
import {
  getPlotItemGroupListService,
  deteleBimPlottedData,
  addBimPlanScenesBusiness,
  plotCheckBeforeAddList,
  plotPrivateCheckBeforeAddList,
  checkBeforeAddList,
  clonePlotData,
} from "@/api/api.js";
import * as plotOperation from "@/components/tables/plotItem/plotConfig.js";
export default {
  name: "plotTreeScript",
  components: {
    MapModal,
    newGroupingPage,
    scenePlottingClon,
    PlotItemPage,
    ImageResources,
  },
  props: ["selectedScene", "getSchemeTree", "modalNodeData", "grouping"],
  data() {
    return {
      plotItem: {
        title: "标绘树",
        id: "plotItem",
      },
      modalNode: {
        plotItem: {
          show: true,
          loading: false,
          width: "380px",
          height: `${
            document.querySelector("#mars3d-container").offsetHeight - 195
          }px`,
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "shpTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            expand: true,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            currentNodeKey: "",
            checkeArr: [],
            search: {
              keywords: "text", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            checkBoxClick: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      newPageShow: false,
      newScenePlotting: false,
      plotItemShow: false,
      groupProps: {
        title: "新建分组",
        id: null,
        name: null,
      },
      currentNode: null,
      checkedIds: [],
      imageResourcesShow: false,
      posCode: window.sessionStorage.getItem("posCode"),
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    // 加入场景之后的监听便于重新勾选上数据
    modalNodeData: function (newVal, oldVal) {
      this.checkedIds = [];
      newVal[2].children.forEach((item) => {
        this.checkedIds.push(item.id);
      });
      this.$refs.plotTree.$refs.modalTree[0].checkChangeArr(this.checkedIds);
    },
    // 点击了场景时，刷列表
    selectedScene: function (newVal, oldVal) {
      if (newVal && newVal.id) {
        this.getData();
        this.plotItemShow = false;
      }
    },
  },
  methods: {
    createPlotItemLayer() {
      this.$nextTick(() => {
        this.$refs.PlotItemPage.deletePlotItemLayer();
      });
    },
    clonePlotDataMethod(val) {
      clonePlotData({
        id: val.id,
        projectId: Number(sessionStorage.getItem("nowProjectId")),
        scenesId:
          this.selectedScene && this.selectedScene.id == val.parentId
            ? this.selectedScene.id
            : "",
      }).then((res) => {
        this.$notify({
          title: `复制成功！`,
          message: "",
          type: "success",
          duration: 960,
          offset: 320,
        });
        this.getData();
        this.getSchemeTree();
      });
    },

    // 获取标绘分组数据
    getData(selectedSceneId) {
      return new Promise((resolve, reject) => {
        console.log("nowProjectId", this.selectedScene);
        const params = {
          ProjectId: sessionStorage.getItem("nowProjectId"),
          DataType: 1,
          scenesId: selectedSceneId
            ? selectedSceneId
            : this.selectedScene
            ? this.selectedScene.id
            : "",
        };
        getPlotItemGroupListService(params).then((res) => {
          const data = res.data.data;
          // 把当前场景下的所有标绘值存储

          plotOperation.getProjectPlotTreeData(data);
          // 一级分组：编辑删除
          const operateGroupingList = [
            {
              i_icon: "small-operation-btn el-icon-plus",
              click: (e) => this.groupAddPlot(e),
            },
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: (e) => this.editGroupName(e),
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: (e) => this.deleteGroup(e),
            },
          ];
          // 二级数据：定位显示编辑删除
          const operateGroupingListSecond = [
            {
              i_icon: "small-operation-btn el-icon-airplane",
              click: (e) => this.aircraftClick(e, "eye"),
            },
            {
              i_icon: "small-operation-btn el-icon-view",
              click: (e) => this.displayPlot(e, "eye"),
            },
            {
              i_icon: "small-operation-btn el-icon-edit",
              click: (e) => this.editPlotData(e),
            },
            {
              i_icon: "small-operation-btn el-icon-copy-document",
              click: (e) => this.clonePlotDataMethod(e),
            },
            {
              i_icon: "small-operation-btn el-icon-delete",
              click: (e) => this.deletePlot(e),
            },
          ];
          if (data.length > 0) {
            data.forEach((item) => {
              if (this.posCode != "guest") item.operate = operateGroupingList;
              if (item.text === "场景标绘") {
                item.disabled = true;
                if (this.posCode != "guest")
                  item.operate = [
                    operateGroupingList[0],
                    {
                      i_icon: "small-operation-btn las la-clipboard",
                      click: (e) => this.clonePlotDataMethodScene(e),
                    },
                  ];
              }
              if (item.children.length > 0) {
                item.children.forEach((etem) => {
                  if (etem.parentId == item.id && item.text === "场景标绘") {
                    etem.disabled = true;
                  }
                  this.setIcon(etem);
                  if (this.posCode != "guest")
                    etem.operate = operateGroupingListSecond;
                });
              }
            });
            this.modalNode.plotItem.content.treeDataJson = data;

            this.$nextTick(() => {
              setTimeout(() => {
                if (this.selectedScene) {
                  this.$refs.plotTree.$refs?.modalTree[0].setCurrentKey(
                    data[data.length - 1].id
                  );
                  this.currentNode = data[data.length - 1].id;
                } else {
                  this.$refs.plotTree.$refs?.modalTree[0].setCurrentKey(
                    data[0].id
                  );
                  this.currentNode = data[0].id;
                }
                this.$refs.PlotItemPage.deletePlotItemLayer();
              }, 1000);
            });
          }
          resolve(data);
        });
      });
    },
    // icon
    setIcon(data) {
      switch (data.bimPlanPainting.shapeType) {
        case 1:
          data.i_icon = "las la-dot-circle";
          break;
        case 2:
          data.i_icon = "las la-slash";
          break;
        case 3:
          data.i_icon = "las la-th-large";
          break;
        case 4:
          data.i_icon = "las la-cube";
          break;
        default:
          data.i_icon = "";
      }
    },
    // 刷新
    getData2() {
      this.modalNode.plotItem.content.checkeArr = this.checkedIds;
      const params = {
        ProjectId: sessionStorage.getItem("nowProjectId"),
        DataType: 1,
        scenesId: this.selectedScene ? this.selectedScene.id : "",
      };
      getPlotItemGroupListService(params).then((res) => {
        // 把当前场景下的所有标绘值存储
        console.log("getProjectPlotTreeData");
        plotOperation.getProjectPlotTreeData(res.data.data);
        // 一级分组：编辑删除
        const operateGroupingList = [
          {
            i_icon: "small-operation-btn el-icon-plus",
            click: (e) => this.groupAddPlot(e),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editGroupName(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deleteGroup(e),
          },
        ];
        // 二级数据：编辑删除
        const operateGroupingListSecond = [
          {
            i_icon: "small-operation-btn el-icon-airplane",
            click: (e) => this.aircraftClick(e, "eye"),
          },
          {
            i_icon: "small-operation-btn el-icon-view",
            click: (e) => this.displayPlot(e, "eye"),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editPlotData(e),
          },
          {
            i_icon: "small-operation-btn el-icon-copy-document",
            click: (e) => this.clonePlotDataMethod(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deletePlot(e),
          },
        ];
        if (res.data.data.length > 0) {
          this.getSchemeTree();
          res.data.data.forEach((item) => {
            if (this.posCode != "guest") item.operate = operateGroupingList;
            if (item.text === "场景标绘") {
              item.disabled = true;
              if (this.posCode != "guest")
                item.operate = [
                  operateGroupingList[0],
                  {
                    i_icon: "small-operation-btn las la-clipboard",
                    click: (e) => this.clonePlotDataMethodScene(e),
                  },
                ];
            }
            if (item.children.length > 0) {
              item.children.forEach((etem) => {
                if (etem.parentId == item.id && item.text === "场景标绘") {
                  etem.disabled = true;
                }
                this.setIcon(etem);
                if (this.posCode != "guest")
                  etem.operate = operateGroupingListSecond;
              });
            }
          });
          this.modalNode.plotItem.content.treeDataJson = res.data.data;
          this.$nextTick(() => {
            this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(
              this.currentNode
            );
          });
        }
      });
    },
    // 分组刷新
    getNewGroupData() {
      this.modalNode.plotItem.content.checkeArr = this.checkedIds;
      const params = {
        ProjectId: sessionStorage.getItem("nowProjectId"),
        DataType: 1,
        scenesId: this.selectedScene ? this.selectedScene.id : "",
      };
      getPlotItemGroupListService(params).then((res) => {
        // 把当前场景下的所有标绘值存储
        plotOperation.getProjectPlotTreeData(res.data.data);
        // 一级分组：编辑删除
        const operateGroupingList = [
          {
            i_icon: "small-operation-btn el-icon-plus",
            click: (e) => this.groupAddPlot(e),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editGroupName(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deleteGroup(e),
          },
        ];
        // 二级数据：编辑删除
        const operateGroupingListSecond = [
          {
            i_icon: "small-operation-btn el-icon-airplane",
            click: (e) => this.aircraftClick(e, "eye"),
          },
          {
            i_icon: "small-operation-btn el-icon-view",
            click: (e) => this.displayPlot(e, "eye"),
          },
          {
            i_icon: "small-operation-btn el-icon-edit",
            click: (e) => this.editPlotData(e),
          },
          {
            i_icon: "small-operation-btn el-icon-copy-document",
            click: (e) => this.clonePlotDataMethod(e),
          },
          {
            i_icon: "small-operation-btn el-icon-delete",
            click: (e) => this.deletePlot(e),
          },
        ];
        if (res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            if (this.posCode != "guest") item.operate = operateGroupingList;
            if (item.text === "场景标绘") {
              item.disabled = true;
              if (this.posCode != "guest")
                item.operate = [
                  operateGroupingList[0],
                  {
                    i_icon: "small-operation-btn las la-clipboard",
                    click: (e) => this.clonePlotDataMethodScene(e),
                  },
                ];
            }
            if (item.children.length > 0) {
              item.children.forEach((etem) => {
                if (etem.parentId == item.id && item.text === "场景标绘") {
                  etem.disabled = true;
                }
                this.setIcon(etem);
                if (this.posCode != "guest")
                  etem.operate = operateGroupingListSecond;
              });
            }
          });
          this.modalNode.plotItem.content.treeDataJson = res.data.data;
          this.$nextTick(() => {
            this.currentNode = res.data.data[res.data.data.length - 2].id;
            this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(
              res.data.data[res.data.data.length - 2].id
            );
          });
        }
      });
    },
    // 飞行定位
    aircraftClick(data, checked) {
      // 取当前
      const graphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 有旧id 并且在图层直接飞
      if (graphic) {
        graphic.flyTo();
      } else {
        // 创建+定位
        plotOperation.operationPlotData(true, data.id);
        plotOperation.flyToPlot(data.id, "fly");
      }
    },
    // 显示隐藏
    displayPlot(data, checked) {
      // 取当前
      const graphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 创建和删除标绘
      if (graphic) {
        plotOperation.operationPlotData(false, data.id);
      } else {
        plotOperation.operationPlotData(true, data.id);
      }
    },
    // 打开添加分组
    addGrouping() {
      this.groupProps = {
        title: "新建分组",
        id: null,
        name: null,
      };
      this.imageResourcesShow = false;
      this.plotItemShow = false;
      this.newPageShow = true;
    },
    // 取消关闭分组
    closeNewGrouping() {
      this.newPageShow = false;
    },
    // 添加分组提交
    onSubmitGroupName() {
      this.currentNode = null;
      this.getNewGroupData();
      this.newPageShow = false;
    },
    // 删除分组
    deleteGroup(e) {
      this.$confirm("您确定要删除此分组吗？", "确认提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        deteleBimPlottedData({ id: e.id }).then((res) => {
          this.$notify({
            title: `删除成功！`,
            message: "",
            type: "success",
            duration: 960,
            offset: 320,
          });
          if (e.children.length > 0) {
            e.children.forEach((item) => {
              this.deleteGroupPlotData(item);
            });
          }
          this.currentNode = null;
          this.getData();
        });
      });
    },
    // 编辑分组名
    editGroupName(e) {
      this.groupProps = {
        title: "编辑分组",
        id: e.id.toString(),
        name: e.text,
      };
      this.newPageShow = true;
    },
    // 一级分组下点击加号时
    groupAddPlot(e) {
      this.currentNode = e.id;
      this.$nextTick(() => {
        this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(this.currentNode);
      });
      this.addPlot();
    },
    // 打开文件资源
    addImgResouces() {
      if (!this.currentNode) {
        return this.$notify({
          title: `请先选择分组`,
          message: "",
          type: "warning",
          duration: 960,
          offset: 320,
        });
      }
      this.newPageShow = false;
      this.plotItemShow = false;
      this.imageResourcesShow = true;
    },
    // 关闭资源
    imageResourcesClose() {
      this.imageResourcesShow = false;
    },
    // 点击新增标绘时
    addPlot() {
      if (!this.currentNode) {
        this.$notify({
          title: `请先选择分组`,
          message: "",
          type: "warning",
          duration: 960,
          offset: 320,
        });
        return false;
      }
      this.newPageShow = false;
      this.imageResourcesShow = false;
      this.plotItemShow = true;
      this.$refs.PlotItemPage.chooseIconPanelClose();
      this.$refs.PlotItemPage.deletePlotItemLayer();
      this.$refs.PlotItemPage.initReset();
    },
    // 编辑标绘
    editPlotData(data) {
      console.log(data, "datadata");
      this.$refs.PlotItemPage.chooseIconPanelClose();
      // 组件当前处于显示状态
      if (this.$refs.plotTreeScript.style.display !== "none") {
        // 先把分组节点传过去
        this.currentNode = data.parentId;
        // 打开标绘弹出层
        this.plotItemShow = true;

        this.$refs.PlotItemPage.deletePlotItemLayer();
        this.$GLOBAL.plotItemLayer.stopEditing();
        plotOperation.operationPlotData(true, data.id);
        this.$nextTick(() => {
          this.$refs.PlotItemPage.resourcesHttp(data.dataType, data.pId);
        });
        const oldGraphic = this.$GLOBAL.plotItemLayer.getGraphicById(
          JSON.parse(data.bimPlanPainting.graphic).id
        );
        // console.log(this.$GLOBAL.plotItemLayer)
        // 有旧数据并且存在图层中
        if (oldGraphic) {
          oldGraphic.startEditing();
          const model = plotOperation.manageFields(data);

          // 显示对应的属性编辑，传递form数据
          this.$refs.PlotItemPage.initFormData(
            data.bimPlanPainting.customType,
            JSON.parse(data.bimPlanPainting.graphic).id
          );
          this.$refs.PlotItemPage.initItemsArr(data.bimPlanPainting.customType);
          this.$refs.PlotItemPage.editMergeForm(model, data.dataType, data.pId);
        } else {
          // 没有旧数据去查
          const graphic = plotOperation.flyToPlot(data.id, "edit");
          if (graphic) {
            // 开启编辑（支持拖动）
            graphic.drawGraphic.startEditing();
            // 显示对应的属性编辑，传递form数据
            this.$refs.PlotItemPage.initFormData(
              graphic.current.bimPlanPainting.customType,
              graphic.current.uid
            );
            this.$refs.PlotItemPage.initItemsArr(
              data.bimPlanPainting.customType
            );
            const data = plotOperation.manageFields(graphic.current);
            this.$refs.PlotItemPage.editMergeForm(
              data,
              data.dataType,
              data.pId
            );
          }
        }
      } else {
        // 组件当前处于隐藏状态
        this.$emit("editPlotEmites", data);
      }
    },
    // 删除分组时清除分组下的标绘数据
    deleteGroupPlotData(data) {
      // 获取旧的
      const oldGraphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
        JSON.parse(data.bimPlanPainting.graphic).id
      );
      // 如果旧在当前图层中
      if (oldGraphic) {
        this.$GLOBAL.plotItemLayer.removeGraphic(oldGraphic);
      } else {
        // 没有去查,首先删除图层上可能被创建过的标绘
        plotOperation.operationPlotData(false, data.id);
      }
    },
    // 删除标绘
    deletePlot(data) {
      // 私有标绘校验
      if (this.selectedScene && data.parentId == this.selectedScene.id) {
        const params = {
          projectId: window.sessionStorage.getItem("nowProjectId"),
          scenesId: this.selectedScene.id,
          id: data.id,
        };
        plotPrivateCheckBeforeAddList(params).then((res) => {
          const { cOperateIds, pModelIds } = res.data.data;
          if (cOperateIds.length == 0) {
            this.$confirm("确认删除？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // 发送请求进行后台删除
                deteleBimPlottedData({ id: data.id }).then((res) => {
                  // 获取旧的
                  const oldGraphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
                    JSON.parse(data.bimPlanPainting.graphic).id
                  );
                  // 如果旧在当前图层中
                  if (oldGraphic) {
                    this.$GLOBAL.plotItemLayer.removeGraphic(oldGraphic);
                  } else {
                    // 没有去查,首先删除图层上可能被创建过的标绘
                    plotOperation.operationPlotData(false, data.id);
                  }
                  this.$notify({
                    title: `删除成功！`,
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                  this.plotItemShow = false;
                  this.currentNode = null;
                  this.getData();
                  this.getSchemeTree();
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "取消",
                });
              });
          } else {
            // 通知栏
            this.$message({
              showClose: true,
              message: `操作（ID：${pModelIds.toString()}）中使用了该资源，无法删除！`,
              duration: 0,
              type: "error",
            });
          }
        });
      } else {
        // 公共标绘校验
        const params = {
          projectId: window.sessionStorage.getItem("nowProjectId"),
          businessType: "BimPlanPainting",
          businessId: data.id,
        };

        plotCheckBeforeAddList(params).then((res) => {
          if (!res.data.data) {
            this.$confirm("确认删除？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              // 发送请求进行后台删除
              deteleBimPlottedData({ id: data.id }).then((res) => {
                // 获取旧的
                const oldGraphic = this.$GLOBAL.plotItemLayer?.getGraphicById(
                  JSON.parse(data.bimPlanPainting.graphic).id
                );
                // 如果旧在当前图层中
                if (oldGraphic) {
                  this.$GLOBAL.plotItemLayer.removeGraphic(oldGraphic);
                } else {
                  // 没有去查,首先删除图层上可能被创建过的标绘
                  plotOperation.operationPlotData(false, data.id);
                }
                this.$notify({
                  title: `删除成功！`,
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
                this.plotItemShow = false;
                this.currentNode = null;
                this.getData();
                this.getSchemeTree();
              });
            });
          } else {
            // 通知栏
            this.$message({
              showClose: true,
              message: `该资源在【${res.data.data}】等场景中被使用，无法删除，请检查`,
              duration: 0,
              type: "error",
            });
          }
        });
      }
    },
    // 行点击事件
    nodeClick(e) {
      this.imageResourcesClose();
      if (e.parentId === 0) {
        // this.plotItemClose();
        this.currentNode = e.id;
      } else {
        this.currentNode = e.parentId;
      }
    },
    // 关闭标绘
    plotItemClose() {
      this.plotItemShow = false;
      this.$nextTick(() => {
        this.$refs.plotTree.$refs.modalTree[0].setCurrentKey(this.currentNode);
      });
    },
    // 关闭整体标绘分组
    plotItem_click() {
      this.plotItemShow = false;
      this.$refs.PlotItemPage.chooseIconPanelClose();
      this.$emit("plotItemClose", "plotItem");
    },
    // 勾选框事件
    checkBoxClick(e, isCheck, arr) {
      if (isCheck) {
        this.checkedIds.push(e.id);
      } else {
        this.checkedIds.forEach((item, index) => {
          if (item === e.id) {
            this.checkedIds.splice(index, 1);
          }
        });
      }
    },
    // 加入场景
    joinScene() {
      let currentNode = this.$refs.plotTree.$refs.modalTree[0].getCurrentNode();
      let businessId = [];
      currentNode.forEach((item) => {
        businessId.push(item.id);
      });
      // this.modalNode.plotItem.content.treeDataJson.forEach((item) => {
      //   if (item.parentId != 0) {
      //     item.children.forEach((etem) => {
      //       businessId.push(etem.id);
      //     });
      //   }
      // });
      let paramsData = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: businessId,
        // 业务类型
        businessType: "BimPlanPainting",
      };
      checkBeforeAddList(paramsData).then((res) => {
        let { code, data } = res.data;
        if (code == 200 || code == 204) {
          if (data && data.cOperateIds.length > 0) {
            this.$message({
              showClose: true,
              message: `操作（ID：${data.pModelIds.toString()}）中使用了资源：${data.dataName.join(
                "，"
              )}。被占用资源无法取消勾选，请检查！`,
              duration: 0,
              type: "error",
            });
          } else {
            addBimPlanScenesBusiness(paramsData)
              .then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.getData();
                  this.getSchemeTree();
                  this.plotItem_click();
                  this.$notify({
                    title: "加入场景成功",
                    message: "",
                    type: "success",
                    duration: 960,
                    offset: 320,
                  });
                } else {
                  this.$notify({
                    title: "加入场景失败",
                    message: "",
                    type: "error",
                    duration: 1000,
                    offset: 320,
                  });
                }
              })
              .catch((error) => {
                this.$notify({
                  title: "加入场景失败",
                  message: "",
                  type: "error",
                  duration: 1000,
                  offset: 320,
                });
              });
          }
        } else {
          this.$notify({
            title: "网络不佳",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        }
      });
    },
    // 克隆标绘到别的场景
    clonePlotDataMethodScene() {
      this.newScenePlotting = true;
    },
    // 关闭克隆标绘到别的场景
    closeScenePlotting() {
      this.newScenePlotting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/box.scss";

/* mixin begin */
/* h3,h4标题基础样式。 */
@mixin self_h3() {
  h3 {
    font-size: 12px;
    @include lheight(30);
    margin: 0;
    text-align: left;
    letter-spacing: 1px;
    width: 100%;
    @include font_color("t_color_op1");
    margin-top: 6px;
    font-weight: bold;
    text-indent: 1px;
  }
}

@mixin self_h4() {
  h4 {
    font-size: 12px;
    @include lheight(26);
    margin: 0;
    text-align: left;
    letter-spacing: 1px;
    width: 100%;
    @include font_color("t_color_op2");
    margin-top: 2px;
    font-weight: bold;
    text-indent: 1px;
  }
}
/* mixin end */

#plotItem {
  .btn-list {
    @include button_default();
    .el-button--default {
      @include lheight(26);
      padding: 0 10px;
      margin-left: 13px;
      span {
        @include lheight(26);
      }
    }
  }
  .type-list {
    width: 92%;
    margin: 0 4%;
    @include self_h3;
    .el-divider {
      margin: 0;
      height: 1px;
      @include background_color("t_color_op2");
    }
    .inner {
      display: block;
      width: 100%;
      padding: 0;
      @include self_h4;
      &:nth-last-of-type(1) {
        padding-bottom: 36px;
      }
      &:not(:nth-last-of-type(4)) {
        h4 {
          margin-top: 12px;
        }
      }
      @include divider_base();
      @include link_base(106, 26, true, true);
    }
  }
  .property-form {
    width: 92%;
    margin: 0 4% 0px 4%;
    .el-collapse {
      border: 0 !important;
      .el-collapse-item {
        .el-collapse-item__content {
          padding-bottom: 0px !important;
        }
        .el-collapse-item__wrap {
          background-color: transparent !important;
          border: 0 !important;
        }
        .el-collapse-item__header {
          height: 35px !important;
          line-height: initial !important;
          color: rgba(255, 255, 255, 0.9) !important;
          background-color: transparent !important;
          border: 0 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          .el-collapse-item__arrow {
            margin: 0 !important;
            margin-right: 10px !important;
          }
        }
      }
    }
    @include self_h3;
    .el-divider {
      margin: 0;
      height: 1px;
      @include background_color("t_color_op2");
    }
    .el-form.settings {
      position: relative;
      width: 100%;
      @include hvcenter(column);
      .el-form-item {
        width: 100%;
        padding: 0 0 0 2px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 12px;
        .saveSumbitBtn {
          position: fixed;
          bottom: 30px;
          right: 35px;
        }
        .el-form-item__label {
          margin-bottom: 0px;
          font-size: 12px;
          @include font_color("t_color_op1");
          padding: 0;
          line-height: 32px;
        }
        .el-form-item__content {
          margin-left: 0px !important;
          font-size: 12px;
          display: flex;
          align-items: center;
          line-height: 32px;
          .el-select {
            @include select_base(200);
            .el-select__tags {
              top: 55%;
            }
            .el-select__tags-text {
              display: inline-block !important;
              max-width: 80px;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              white-space: nowrap !important;
            }
            .el-tag__close.el-icon-close {
              top: -7px !important;
              right: -4px !important;
            }
          }
          .el-input {
            @include input_base(200);
          }
          @include switch_base();
          .el-input-number {
            @include input_number();
          }
          .el-textarea {
            @include textarea_base(200);
          }

          .el-slider {
            width: 50%;
          }
          .el-form-item__error {
            padding-top: 3px;
          }
        }
        &.color-pick {
          .el-color-picker {
            /* height: 26px !important; */
            height: 20px !important;
            line-height: 20px !important;
            width: 20px;
            padding: 0;

            .el-color-picker__trigger {
              border: none;
              height: 20px !important;
              line-height: 20px !important;
              width: 20px;
              padding: 0;
              .el-color-picker__color {
                border: none;
              }
              span.el-icon-arrow-down {
                // display: none;
              }
            }
          }
          span.label-text {
            @include font_color("t_color_op1");
            margin-left: 16.5px;
          }
        }
        &.slider {
          .el-form-item__content {
            flex-basis: 120px;
            @include slider_base();
            .el-slider {
              margin-top: 4px;
            }
          }
        }
        &.icon-choose-btn {
          .el-form-item__content {
            @include link_base(136, 26, true, true);
            .el-link {
              &.current {
                &::after {
                  box-sizing: border-box;
                  content: "";
                  position: absolute;
                  left: 0;
                  right: 0;
                  height: 0;
                  bottom: 0;
                  border-bottom: 1px solid #409eff;
                  border-color: rgba(0, 255, 255, 0.9) !important;
                }
              }
            }
          }
        }
        &.btns {
          padding: 1px 0 0 82px;
          .el-form-item__content {
            width: 166px;
            .el-button--primary {
              @include lheight(28);
              @include font_color("t_color_op1");
              // @include background_color("t_color1_op2");
              // @include border_color("t_color1_op2");
              padding: 0 15px;
              margin: 2px 16px 0 0;
              span {
                @include lheight(28);
                font-size: 12px;
                display: block;
                text-align: center;
              }
              &:hover {
                @include background_color("t_color1_op1");
                @include border_color("t_color1_op1");
              }
              &.is-disabled {
                @include font_color("t_color_sc1");
                @include background_color("t_color1_op3");
                @include border_color("t_color1_op3");
                span {
                  background: none;
                  @include font_color("t_color_sc1");
                }
              }
            }
            .el-button--default {
              @include lheight(28);
              @include font_color("t_color_op2");
              @include background_color("t_color3_op2");
              @include border_color("t_color_op2");
              padding: 0 15px;
              margin: 6px 16px 0 6px;
              span {
                @include lheight(24);
                font-size: 12px;
                display: block;
                text-align: center;
              }
              &:hover {
                @include background_color("t_color3_op1");
                @include border_color("t_color_op1");
                @include font_color("t_color_op1");
              }
            }
          }
        }
        &:first-child {
          padding-top: 10px;
        }
      }
    }
  }
  .foot-operate {
    padding: 10px 10px;
    border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
    justify-content: flex-end;
    align-items: center;
    display: flex;
    .el-button.el-button--primary {
      margin: 0px !important;
      font-size: 14px;
      padding: 0px 10px;
      line-height: 30px;
      height: 30px !important;
    }
  }
}
.head-operate {
  padding: 0 5px 10px 5px;
  margin: 0 -5px !important;
}
.option-index {
  background-color: #909399;
  color: #fff;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  right: 16px;
  padding: 0px 7px;
  line-height: 22px;
  margin: 3px auto;
  z-index: 99;
}
</style>
